import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { RootState } from "../Store";
import MainLayout from "../Layouts/MainLayout";
import Input from "../Components/Input";

import styles from "../Styles/Forms.module.css";
import useFetch from "../Hooks/useFetch";

function MessageEdit() {
  const navigate = useNavigate();
  const { id }: any  = useParams();
  const token: any = useSelector((state: RootState) => state.auth.token);
  const [cover, setCover] = useState<any>(null);
  const [name, setName] = useState<any>(null);
  const [audio, setAudio] = useState<any>(null);
  const [duration, setDuration] = useState<any>(null);
  const { data, error, loading }: any = useFetch(`/messages/${id}`, token);

  useEffect(() => {
    if (data) {
      setName(data.name);
      setDuration(data.duration);
    }
  }, [data, setCover, setName, setAudio, setDuration]);

  const uploadData = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();

    if (cover) {
      formData.append("cover", cover);
    }
    
    if (name) {
      formData.append("name", name);
    }
    
    if (audio) {
      formData.append("audio", audio);
    }
    
    if (duration) {
      formData.append("duration", duration);
    }    
    
    try {
      await axios.put(`/messages/${id}`, formData, {
        headers: {
          Authorization: token
        }
      });

      navigate('/messages');
    } catch (error: any) {
      console.error("Error: ", error);
      alert(error.response.message);
    }
  };

  return (
    <MainLayout>
      <div className={styles.formContainer}>
        <header>
          <h1>Edit Message</h1>
        </header>
        <form onSubmit={uploadData}>
          <div className={styles.formControl}>
            <Input type="file" name="Cover" state={cover} setState={setCover} />
          </div>
          <div className={styles.formControl}>
            <Input name="Name" state={name} setState={setName} />
          </div>
          <div className={styles.formControl}>
            <Input type="file" name="Audio" state={audio} setState={setAudio} />
          </div>
          <div className={styles.formControl}>
            <Input name="Repeat Every? (In Seconds)" state={duration} setState={setDuration} />
          </div>
          <div className={styles.formControl}>
            <button className={styles.submitButton}>Edit Message</button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
}

export default MessageEdit;
